<template>
  <div class="content_block_container">
    <b-row class="content_block_topbar">
      <b-col cols="6"
        ><h5 class="title_content_block">{{ link.text }}</h5></b-col
      >
      <b-col style="text-align: right">
        <b-button
          class="controller_button_content"
          @click="$emit('shiftUpLink', index)"
          ><b-icon icon="caret-up-fill" aria-hidden="true"></b-icon
        ></b-button>
        <b-button
          class="controller_button_content"
          @click="$emit('shiftDownLink', index)"
          ><b-icon icon="caret-down-fill" aria-hidden="true"></b-icon
        ></b-button>
        <b-button
          class="controller_button_content"
          @click="$emit('deleteLink', index)"
          ><b-icon icon="trash-fill" aria-hidden="true"></b-icon
        ></b-button>
      </b-col>
    </b-row>
    <b-container class="form_button_content">
      <b-row >
        <b-col md="4">
          <b-form-input v-model="link.text" placeholder="Titre"></b-form-input>
        </b-col>
        <b-col md="4">
          <b-form-input v-model="link.url" placeholder="Url"></b-form-input>
        </b-col>
        <b-col md="4">
          <b-row style="margin-top:0;">
            <b-col cols="9">
              <b-form-input
                v-model="link.icon"
                placeholder="Icon"
              ></b-form-input>
              <a
                style="color: black; font-size: 0.8rem"
                href="https://fontawesome.com/v5.15/icons?d=gallery&p=2&s=solid&m=free"
                target="_blank"
                >Liste des icons</a
              >
            </b-col>
            <b-col cols="3"
              ><p class="align_center" style="margin-top: 8px">
                <v-icon
                  scale="2"
                  v-if="link.icon"
                  :name="link.icon"
                ></v-icon></p
            ></b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["link", "index"],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
</style>